/**
 * Created by anthony on 6/21/14.
 */
let familyTaxFamilyModel = angular.module("familyTaxFamilyModel", ["familyTaxModel", "familyModel"]);
let familyTaxFamilyService = function(ApplicationService, FamilyTaxModelService, FamilyModelService,
    $q, TaxLogModelService) {
    return {
        putHelper: function(putDataFamilyTax, putDataFamily, instance) {
            return $q.all([
                FamilyTaxModelService.put(putDataFamilyTax.familyID, putDataFamilyTax, instance),
                FamilyModelService.put(putDataFamilyTax.familyID, putDataFamily, instance)
            ]);
        },
        putLog: function(putDataFamilyTax) {
            let d = new Date();
            let dt = d.getFullYear().toString() + "-" + (d.getMonth() + 1).toString() + "-" + d.getDate().toString();
            let time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
            let postObject = {
                familyID: putDataFamilyTax.familyID,
                date: dt,
                time: time,
                note: "School changed year collection preference",
                added: 0
            };
            return TaxLogModelService.post(putDataFamilyTax.familyID, postObject);
        }
    };
};
familyTaxFamilyModel.service("FamilyTaxFamilyService", familyTaxFamilyService);
